<template>
  <div
    id="themes"
    class="content"
  >
    <div id="content">
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-palette"></i> Thèmes
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Les thèmes permettent de modifier l'apparence des Weezys ainsi que des guirlandes LED.
          <br>
          Pour <strong>saisir</strong> un nouveau Thème, cliquez sur "<strong><i class="far fa-plus-circle"></i> Ajouter un Thème"</strong>, puis remplissez la totalité des champs.
          <br>
          Pour <strong>modifier</strong> les différentes entrées de la liste, éditez les champs que vous souhaitez en cliquant dessus.
          <br>
          Pour <strong>supprimer</strong> des Thèmes, cochez les lignes puis cliquez sur le bouton <strong>"Supprimer"</strong>.
        </b-message>
      </div>
    </div>
    <themesTable
      id="themesTable"
      :themes="themes"
      :checkable="true"
    />
  </div>
</template>


<script>
/* Import components */
import themesTable from "@/components/themesTable";

/* Import modules */
import http from "@/modules/request";

export default {
  name: "themes",
  components: {
    themesTable
  },
  data() {
    return {
      themes: [],
      themeId: "",
      name: "",
      color_1: "",
      color_2: "",
      anim_sale: "",
      anim_win: "",
      isComponentModalActive: false,
      isDeleteConfirmationModalActive: false
    };
  },
  mounted() {
    this.getThemes();
  },
  methods: {
    getThemes() {
      http
        .get("/themes")
        .then(response => {
          var dataThemes = response.data;
          for (var i = 0; i < dataThemes.length; i++) {
            //Convert Data to date
            dataThemes[i].color_1 = this.RgbToHex(dataThemes[i].color_1);
            dataThemes[i].color_2 = this.RgbToHex(dataThemes[i].color_2);
          }
          this.themes = dataThemes;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
          if (error.response.status === 401) {
            console.log("unauthorized, logging out ...");
          }
          return Promise.reject(error.response);
        });
    },
    submitAdd: function() {
      var color1 =
        this.color_1.hex == undefined
          ? this.hexToRgb(this.color_1)
          : this.hexToRgb(this.color_1.hex);
      var color2 =
        this.color_2.hex == undefined
          ? this.hexToRgb(this.color_2)
          : this.hexToRgb(this.color_2.hex);
      http
        .post("/themes", {
          theme: {
            name: this.name,
            color_1: color1,
            color_2: color2,
            anim_sale: this.anim_sale,
            anim_win: this.anim_win
          }
        })
        .then(
          function(response) {
            this.succesToast("Thème ajouté avec succès");
            this.getThemes();
            this.isComponentModalActive = false;
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de l'ajout");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    submitModify: function() {
      var color1 =
        this.color_1.hex == undefined
          ? this.hexToRgb(this.color_1)
          : this.hexToRgb(this.color_1.hex);
      var color2 =
        this.color_2.hex == undefined
          ? this.hexToRgb(this.color_2)
          : this.hexToRgb(this.color_2.hex);
      http
        .patch("/themes/" + this.themeId, {
          theme: {
            name: this.name,
            color_1: color1,
            color_2: color2,
            anim_sale: this.anim_sale,
            anim_win: this.anim_win
          }
        })
        .then(
          function(response) {
            this.succesToast("Thème(s) modifié(s) avec succès");
            this.getThemes();
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de modification");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    submitDelete: function() {
      http
        .delete("/themes/" + this.themeId)
        .then(
          function(response) {
            this.succesToast("Thème(s) supprimé(s) avec succès");
            this.getThemes();
            this.isDeleteConfirmationModalActive = false;
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de suppression");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    clearFields: function() {
      this.themeId = "";
      (this.name = ""), (this.color_1 = ""), (this.color_2 = "");
      (this.anim_sale = ""), (this.anim_win = "");
    },
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? parseInt(result[1], 16).toString() +
            "-" +
            parseInt(result[2], 16).toString() +
            "-" +
            parseInt(result[3], 16).toString()
        : 0 - 0 - 0;
    },
    RgbToHex(rgb) {
      var rgbArray = rgb.split("-");
      var rgb = rgbArray[2] | (rgbArray[1] << 8) | (rgbArray[0] << 16);
      return "#" + (0x1000000 + rgb).toString(16).slice(1);
    },
    deleteCheckedRows(checkedThemes) {
      var count = checkedThemes.length;
      for (var i = 0; i < count; i++) {
        this.themeId = checkedThemes[i].id;
        this.submitDelete();
      }
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.themeId = modified.id;
          this.name = modified.name;
          this.color_1 = modified.color_1;
          this.color_2 = modified.color_2;
          this.anim_sale = modified.anim_sale;
          this.anim_win = modified.anim_win;
          this.submitModify();
        }
      }
    },
    modifyRow(row) {
      this.themeId = row.id;
      this.name = row.name;
      this.color_1 = row.color_1;
      this.color_2 = row.color_2;
      this.anim_sale = row.anim_sale;
      this.anim_win = row.anim_win;
      this.submitModify();
    },
    addNewRow(rows) {
      this.color_1 = rows.color_1;
      this.color_2 = rows.color_2;
      this.name = rows.name;
      this.anim_sale = rows.anim_sale;
      this.anim_win = rows.anim_win;
      this.submitAdd();
    },
    errorToast(message) {
      this.$toast.open({
        duration: 3000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}

.add-theme {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>